import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home.component';
import { AppGuard } from '../../app.guard';

const routes: Routes = [
  { path: 'home', component: HomeComponent, pathMatch: 'full', canActivate: [AppGuard] }, // Home
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
